function countries_in_area(area_field, country_selector, prefecture_selector) {
  if(area_field.value === "") {
    return false;
  }
  let url = area_field.dataset.url + area_field.value;
  let $country = $(country_selector);
  let country_options = `<option value=0>${$country.data('prompt')}</option>`;
  let $prefecture = $(prefecture_selector);
  let prefecture_options = `<option value=0>${$prefecture.data('prompt')}</option>`;

  $.ajax({
    url: url
  }).done(function(data) {
    $prefecture.html(prefecture_options);
    data['entries']['countries'].forEach(function(country){
      country_options += `<option value=${country["id"]}>${country["description"]}</option>`
    });
    $country.html(country_options);
  })
}

function prefectures_in_country(country_field, prefecture_selector) {
  if(country_field.value === "") {
    return false;
  }
  let url = country_field.dataset.url + country_field.value;
  let $prefecture = $(prefecture_selector);
  let prefecture_options = `<option value=0>${$prefecture.data('prompt')}</option>`;

  $.ajax({
    url: url
  }).done(function(data) {
    data['entries']['prefectures'].forEach(function(prefecture){
      prefecture_options += `<option value=${prefecture["id"]}>${prefecture["description"]}</option>`
    });
    $prefecture.html(prefecture_options);
  })
}

export { countries_in_area, prefectures_in_country }
